import {
  editDoctor,
  createDoctor,
  editPractice,
  createPractice,
  deletePractice,
  deletePracticePatient,
  getAllPractices,
  getDashboardStats,
  getPracticeDoctors,
  getFilteredPractices,
  getPracticeFinancingOptions,
  createPracticeFinancingOption,
  updatePracticeFinancingOption,
  deletePracticeFinancingOption,
  getFinancingPartners,
  createFinancingPartner,
  updateFinancingPartner,
  deleteFinancingPartner,
} from "./adminApi";
import { createSlice } from "@reduxjs/toolkit";

export const adminSlice = createSlice({
  name: "admin",
  initialState: {
    error: null,
    loading: "idle",
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllPractices.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(getAllPractices.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(getAllPractices.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(createPractice.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(createPractice.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(createPractice.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(deletePractice.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(deletePractice.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(deletePractice.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(deletePracticePatient.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(deletePracticePatient.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(deletePracticePatient.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(editPractice.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(editPractice.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(editPractice.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(createDoctor.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(createDoctor.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(createDoctor.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(getPracticeDoctors.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(getPracticeDoctors.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(getPracticeDoctors.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(getFilteredPractices.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(getFilteredPractices.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(getFilteredPractices.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(getDashboardStats.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(getDashboardStats.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(getDashboardStats.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(editDoctor.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(editDoctor.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(editDoctor.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(getPracticeFinancingOptions.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(getPracticeFinancingOptions.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(getPracticeFinancingOptions.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(createPracticeFinancingOption.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(createPracticeFinancingOption.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(createPracticeFinancingOption.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(updatePracticeFinancingOption.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(updatePracticeFinancingOption.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(updatePracticeFinancingOption.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(deletePracticeFinancingOption.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(deletePracticeFinancingOption.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(deletePracticeFinancingOption.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(getFinancingPartners.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(getFinancingPartners.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(getFinancingPartners.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(createFinancingPartner.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(createFinancingPartner.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(createFinancingPartner.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(updateFinancingPartner.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(updateFinancingPartner.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(updateFinancingPartner.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(deleteFinancingPartner.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(deleteFinancingPartner.fulfilled, (state) => {
        state.loading = "succeeded";
      })
      .addCase(deleteFinancingPartner.rejected, (state) => {
        state.loading = "failed";
      });
  },
});

export default adminSlice.reducer;
